/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { ChannelInterface } from "../../interfaces/Channel.interface";
// CONSTANTS
import { BLANK_CHANNEL } from "../../constants/channels";
import { FormAction } from "../../types/enums";

/**
 * State of the channel slice: the channel currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface ChannelState {
  channel: ChannelInterface;
  channelTableParams: any;
  channelList: Array<any>;
  openDrawerChannel: boolean;
  openModalCreateNewChannel: boolean;
  formCreateEdit: FormAction;
  channelRefreshTable: boolean;
  clearFilters: boolean;
  openModalDeleteChannel: boolean;
  openModalEditChannel: boolean;
  renderComponent: string;
  formAction: FormAction;
}

const initialState: ChannelState = {
  channel: { ...BLANK_CHANNEL },
  channelTableParams: {
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
  },
  openDrawerChannel: false,
  formCreateEdit: FormAction.Create,
  channelList: [],
  openModalCreateNewChannel: false,
  channelRefreshTable: false,
  clearFilters: false,
  openModalDeleteChannel: false,
  openModalEditChannel: false,
  renderComponent: "channels",
  formAction: FormAction.Create,
};

export const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    updateChannel: (state, action: PayloadAction<ChannelInterface>) => {
      state.channel = action.payload;
    },
    updateChannelTableParams: (state, action: PayloadAction<any>) => {
      state.channelTableParams = action.payload;
    },
    updateChannelList: (state, action: PayloadAction<any>) => {
      state.channelList = action.payload;
    },
    updateOpenDrawerChannel: (state, action: PayloadAction<boolean>) => {
      state.openDrawerChannel = action.payload;
    },
    updateFormCreateEdit: (state, action: PayloadAction<FormAction>) => {
      state.formCreateEdit = action.payload;
    },
    updateOpenModalCreateNewChannel: (state, action: PayloadAction<boolean>) => {
      state.openModalCreateNewChannel = action.payload;
    },
    updateChannelRefreshTable: (state, action: PayloadAction<boolean>) => {
      state.channelRefreshTable = action.payload;
    },
    updateClearFilters: (state, action: PayloadAction<boolean>) => {
      state.clearFilters = action.payload;
    },
    updateOpenModalDeleteChannel: (state, action: PayloadAction<boolean>) => {
      state.openModalDeleteChannel = action.payload;
    },
    updateOpenModalEditChannel: (state, action: PayloadAction<boolean>) => {
      state.openModalEditChannel = action.payload;
    },
    updateRenderComponent: (state, action: PayloadAction<string>) => {
      state.renderComponent = action.payload;
    },
    updateFormAction: (state, action: PayloadAction<FormAction>) => {
      state.formAction = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateChannel,
  updateChannelTableParams,
  updateChannelList,
  updateOpenDrawerChannel,
  updateFormCreateEdit,
  updateOpenModalCreateNewChannel,
  updateChannelRefreshTable,
  updateClearFilters,
  updateOpenModalDeleteChannel,
  updateOpenModalEditChannel,
  updateRenderComponent,
  updateFormAction,
} = channelSlice.actions;

export default channelSlice.reducer;
